import React from 'react';
import { Popup } from 'react-mapbox-gl';
import {BASE_URL} from "../../environment/environment";
import * as urls from "../../config/urls";
import noImage from '../../asset/images/icon/no-image-icon.png';
import {numberWithCommas} from "../../helper/functions";

const CustomPopup = ({property, closePopup, onClick}) => {
  return (
      <Popup
          coordinates={property.location.coordinates}
          onClose={closePopup}
          closeButton={true}
          closeOnClick={false}
          offset={{
            'bottom-left': [12, -38],  'bottom': [0, -38], 'bottom-right': [-12, -38]
          }}>
        <div className={'popup-container d-flex justify-content-between'} onClick={() => {
          onClick()
        }}>
          {
            property.files && property.files.length ? (
              <img src={`${BASE_URL}${urls.FILE_BY_UUID}/${property.files[0]}?size=thumbnails`} alt="file" />
            ) : (
              <img src={noImage} alt="file" />
            )
          }
          <div>
            <div>
              <span className={'property-name'}>{property.propertyName}</span>
            </div>
            <div>
              <span className={'property-meter-key'}>متراژ: </span>
              <span className={'property-meter-value'}>120 متر</span>
            </div>
            <div className={'price-container'}>
              <span className={'property-price-key'}>قیمت: </span>
              <span className={'property-price-value'}> {property.overallPrice ? numberWithCommas(property.overallPrice) : 'توافقی'} </span>
              {
                (property.overallPrice) && (
                    <span className={'property-price-key'}>تومان</span>
                )
              }
            </div>
          </div>
        </div>
      </Popup>
  )};

export default CustomPopup;